import React from 'react'
import { Link } from 'react-router-dom';
import reducedLogo from "../assets/reducedLogo.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faBars} from '@fortawesome/free-solid-svg-icons'

function Navbar() {

  const bars = <FontAwesomeIcon icon={faBars} />
    return (
        <div>
            <nav className="navbar navbar-expand-md py-0" style={{backgroundColor: "#4f575a"}}>
      <div className="container font-monospace">
        <Link to="/" className="navbar-brand link">
          <img
            src={reducedLogo}
            className="img-fluid"
            style={{width: "30px"}}
            alt="logo"
          />
          {/* <!-- <span className="text-light mx-3">Home</span> --> */}
        </Link>

        <button
          className="navbar-toggler"
          data-bs-toggle="collapse"
          data-bs-target="#collapseNav"
        >
          <span className="text-light">{bars}</span>
        </button>

        <div className="collapse navbar-collapse flex-grow-0" id="collapseNav">
          <div className="navbar-nav text-center">
            <Link to="/" className="nav-item nav-link text-light my-auto mx-3">
              <span className="mylink h5">Home</span> 
            </Link>
            <Link to="/gallery" className="nav-item nav-link text-light my-auto mx-3">
            <span className="mylink h5">Gallery</span>
            </Link>
            <Link to="/blogs" className="nav-item nav-link text-light my-auto mx-3">
            <span className="mylink h5">Blogs</span>
            </Link>
            <Link to="/about" className="nav-item nav-link text-light my-auto mx-3">
            <span className="mylink h5">About</span>
            </Link>
          </div>
        </div>
      </div>
    </nav>
        </div>
    )
}

export default Navbar;